import { RESET_PASSWORD, SAVE_SETTINGS, UPLOAD_LOGO, VIEW_SETTINGS } from "./types";

export const viewSettingsAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_SETTINGS,
        data,
        onSuccess,
        onError,
    };
};


export const saveSettingsAction = (data, onSuccess, onError) => {
    return {
        type: SAVE_SETTINGS,
        data,
        onSuccess,
        onError,
    };
};

export const resetPasswordsAction = (data, onSuccess, onError) => {
    return {
        type: RESET_PASSWORD,
        data,
        onSuccess,
        onError,
    };
};


export const uploadLogoAction = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_LOGO,
        file,
        onSuccess,
        onError,
    };
};
